// Native modality keeps the browser's focus and inert behavior in every screen.
export function Modal({ label, descriptionId, dir, onClose, className = 'dlg card', children }) {
  const ref = React.useRef(null);
  React.useLayoutEffect(() => {
    const dialog = ref.current;
    const trigger = document.activeElement;
    dialog.showModal();
    return () => {
      dialog.close();
      if (trigger?.isConnected) trigger.focus();
      else document.getElementById('main-content')?.focus();
    };
  }, []);
  const dismiss = (event) => {
    if (event.target !== event.currentTarget) return;
    const box = event.currentTarget.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) onClose();
  };
  return <div className="dlg-backdrop">
    <dialog ref={ref} className={className} dir={dir} aria-label={label} aria-describedby={descriptionId}
            onCancel={event => { event.preventDefault(); onClose(); }} onClick={dismiss}>
      {children}
    </dialog>
  </div>;
}

// Manual activation avoids fetching another pane just to move keyboard focus.
export function useTabFocus(selected) {
  const ref = React.useRef(null);
  const [focused, setFocused] = React.useState(selected);
  React.useLayoutEffect(() => {
    if (!ref.current?.contains(document.activeElement)) setFocused(selected);
  }, [selected]);
  return { ref, focused, onFocus: event => setFocused(event.target.id) };
}

export function tabKeys(event) {
  if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  const tabs = [...event.currentTarget.querySelectorAll('[role="tab"]')];
  const current = tabs.indexOf(event.target);
  if (current < 0) return;
  const rtl = getComputedStyle(event.currentTarget).direction === 'rtl';
  const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1
    : (current + ((event.key === 'ArrowRight') !== rtl ? 1 : -1) + tabs.length) % tabs.length;
  event.preventDefault();
  tabs[next].focus();
}
